import { type TFunction } from '!/i18n'

type TvShowEpisodeTitleParams = {
  seasonNumber?: string
  episodeNumber?: string
  episodeName: string
  t: TFunction
}

export const getTvShowEpisodePaymentTitle = ({
  seasonNumber,
  episodeNumber,
  episodeName,
  t,
}: TvShowEpisodeTitleParams): string => {
  const hasSeasonAndEpisodeNumber = seasonNumber && episodeNumber
  const hasOnlyEpisodeNumber = !seasonNumber && episodeNumber

  const season = t('season_number', {
    number: Number(seasonNumber),
  })

  const episodeCount = Number(episodeNumber)

  const episode = t('episode_number', {
    number: episodeCount,
  })

  if (hasSeasonAndEpisodeNumber) {
    return `${season}, ${episode}: ${episodeName}`
  }

  if (hasOnlyEpisodeNumber) {
    return `${episode}: ${episodeName}`
  }

  return episode
}

type TvShowSeasonTitleParams = {
  seasonNumber?: string
  t: TFunction
}

export const getTvShowSeasonPaymentTitle = ({
  seasonNumber,
  t,
}: TvShowSeasonTitleParams): string => {
  return t('season_number', {
    number: Number(seasonNumber),
  })
}

type TvShowEpisodesLabelsParams = {
  episodesQuantity: number
  year?: string
  t: TFunction
}
export const getTvShowEpisodesLabels = ({
  episodesQuantity,
  year,
  t,
}: TvShowEpisodesLabelsParams): string[] => {
  const totalEpisodesInSeasonString = t('episode_count', {
    count: episodesQuantity,
  })
  return [totalEpisodesInSeasonString, String(year)].filter(Boolean)
}
